import NewsAndActiveList from '@/views/App/Unemployed/List/NewAndActive/List.vue';
import FinishedList from '@/views/App/Unemployed/List/Finished/List.vue';
import PotentialList from '@/views/App/Unemployed/List/Potential/List.vue';
import UnemployedForm from '@/views/App/Unemployed/Form/Form.vue'
import PotentialForm from '@/views/App/Unemployed/Form/PotentialForm.vue'
import DocumentUpload from "@/views/App/Unemployed/DocumentUpload.vue";

const routesUnemployed = [
    {
        path: 'list/active-and-new',
        name: 'unemployedNewAndActiveList',
        component: NewsAndActiveList
    },
    {
        path: 'list/finished',
        name: 'unemployedFinishedList',
        component: FinishedList
    },
    {
        path: 'list/potential',
        name: 'unemployedPotentialList',
        component: PotentialList
    },
    {
        path: 'form',
        name: 'unemployedForm',
        component: UnemployedForm
    },
    {
        path: 'form/:id?',
        name: 'unemployedEditForm',
        component: UnemployedForm
    },
    {
        path: 'potential-form',
        name: 'unemployedPotentialForm',
        component: PotentialForm
    },
    {
        path: 'potential-form/:id?',
        name: 'unemployedPotentialForm',
        component: PotentialForm
    },

    // Document upload
    {
        path: 'document-upload/:id/:routeForBack',
        name: 'unemployedDocumentUpload',
        component: DocumentUpload
    },
];

export default routesUnemployed;